import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import jsPDF from "jspdf";
import "./VehicleLoanEmiDetails.css";
import { fetchUserProfile } from "../redux/slices/branch/userProfileSlice";
import axios from "axios";
import { toast } from "react-toastify";

const VehicleLoanEmiDetails = () => {
  const { loanId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const loan = location.state?.loan;

  const [emis, setemis] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [count, setcount] = useState(0);

  const { profile } = useSelector((state) => state.userProfile);

  const [company, setCompany] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedEmi, setSelectedEmi] = useState(null);
  const [submitting, setSubmitting] = useState(false);

  const [paymentData, setPaymentData] = useState({
    amountPaid: "",
    paymentMode: "Cash",
    paymentDate: new Date().toISOString().split("T")[0],
    remark: "",
  });

  const [previewUrl, setPreviewUrl] = useState(null);
  const [showPreview, setShowPreview] = useState(false);

  useEffect(() => {
    dispatch(fetchUserProfile());
  }, [dispatch]);

  useEffect(() => {
    fetchemis();
    if (profile?.superAdminId) fetchCompany();
  }, [loanId, profile?.superAdminId]);

  useEffect(() => {
    fetchemis();
  }, [currentPage]);

  const fetchCompany = async () => {
    try {
      const res = await fetch(
        `https://payyug.in/api/get-company?superAdminId=${profile?.superAdminId}`
      );
      const data = await res.json();
      if (data?.logo) {
        data.logoUrl = `https://payyug.in/${data.logo.replace(/^images\//, "")}`;
      }
      setCompany(data);
    } catch (err) {
      console.error(err);
    }
  };

  // ⚠ API NOT CHANGED
  const fetchemis = async (page = currentPage) => {
    try {
      const res = await axios.get(`https://payyug.in/api/gold-loan/due-report/all`, {
        params: {
          superAdminId: profile.superAdminId,
          goldLoanId: loan.id,
          page,
          limit: 10,
        },
      });

      setemis(res.data?.data || []);
      setTotalPages(res.data.totalPages || 1);
      setcount(res.data.totalRecords || 0);
    } catch (err) {
      console.error(err);
    }
  };

  const handlePayClick = (emi) => {
    setSelectedEmi(emi);
    setPaymentData({
      amountPaid: emi.emiAmount,
      paymentMode: "Cash",
      paymentDate: new Date().toISOString().split("T")[0],
      remark: "",
    });
    setShowModal(true);
  };

  const handleSubmitPayment = async () => {
    if (!selectedEmi) return;

    try {
      setSubmitting(true);

      const payload = {
        paymentAmount: paymentData.amountPaid,
        paymentMode: paymentData.paymentMode,
        collectedBy: profile.id,
      };

      // ⚠ API NOT CHANGED
      await axios.post(
        `https://payyug.in/api/gold-loan/pay-loan/${selectedEmi.id}`,
        payload
      );

      toast.success("✅ Payment Successful");
      fetchemis();
      setShowModal(false);
    } catch {
      toast.error("❌ Payment Failed");
    } finally {
      setSubmitting(false);
    }
  };

  const formatDate = (d) =>
    d ? new Date(d).toLocaleDateString("en-GB") : "-";

  const formatCurrency = (n) =>
    `Rs. ${Number(n || 0).toLocaleString("en-IN", {
      minimumFractionDigits: 2,
    })}`;

  const loadLogoAsDataURL = (src) =>
    new Promise((resolve) => {
      if (!src) return resolve(null);
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;
        canvas.getContext("2d").drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/png"));
      };
      img.onerror = () => resolve(null);
      img.src = src;
    });

  const buildEmiSlipPDF = async (emi) => {
    if ((emi.status || "").toLowerCase() !== "paid") {
      toast.warn("Slip available only for PAID EMI");
      return null;
    }

    const doc = new jsPDF({ unit: "pt", format: "a4" });
    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 40;

    const logoDataURL = await loadLogoAsDataURL(
      company?.logoUrl || "/techvisionlogo.jpg"
    );

    if (logoDataURL) {
      doc.addImage(logoDataURL, "PNG", margin, margin, 65, 65);
    }

    doc.setFont("helvetica", "bold").setFontSize(20);
    doc.text(
      company?.name || "TechVision Finance",
      margin + 80,
      margin + 22
    );

    doc.setFont("helvetica", "normal").setFontSize(11);
    doc.text(
      `Email: ${company?.email || "-"} | Phone: ${company?.contact || "-"}`,
      margin + 80,
      margin + 42
    );

    doc.setFont("helvetica", "bold").setFontSize(15);
    doc.text("Vehicle Loan EMI Payment Slip", margin, margin + 95);

    let y = margin + 125;

    const leftInfo = [
      ["Customer Name", loan?.memberName],
      ["Loan Account No", loan?.loanAccountNumber],
      ["EMI No", emi?.installmentNo],
    ];

    const rightInfo = [
      ["Paid Date", formatDate(emi.paidDate)],
      ["Due Date", formatDate(emi.dueDate)],
      ["Payment Mode", emi.payment1Mode || "-"],
    ];

    doc.setFontSize(12).setFont("helvetica", "bold");

    leftInfo.forEach(([label, value], i) => {
      doc.text(`${label}:`, margin, y + i * 20);
      doc.setFont("helvetica", "normal");
      doc.text(String(value || "-"), margin + 130, y + i * 20);
      doc.setFont("helvetica", "bold");
    });

    rightInfo.forEach(([label, value], i) => {
      doc.text(`${label}:`, pageWidth / 2, y + i * 20);
      doc.setFont("helvetica", "normal");
      doc.text(String(value || "-"), pageWidth / 2 + 130, y + i * 20);
      doc.setFont("helvetica", "bold");
    });

    y += 80;

    const emiDetails = [
      ["EMI Amount", formatCurrency(emi.emiAmount)],
      ["Payment Status", emi.status],
    ];

    emiDetails.forEach(([label, value], i) => {
      doc.setFont("helvetica", "bold");
      doc.text(label, margin, y + i * 22);
      doc.setFont("helvetica", "normal");
      doc.text(String(value || "-"), pageWidth / 2, y + i * 22);
    });

    y += 60;

    doc.setFont("helvetica", "bold").setFontSize(13);
    doc.text("Outstanding Balance:", margin, y);
    doc.setFont("helvetica", "normal");
    doc.text(formatCurrency(emi.outstanding || 0), pageWidth / 2, y);

    y += 50;

    doc.setFont("helvetica", "italic").setFontSize(10);
    doc.text(
      "This is a system-generated EMI slip. No signature required.",
      margin,
      y
    );

    return doc;
  };

  const generateEmiSlipPDF = async (emi) => {
    const doc = await buildEmiSlipPDF(emi);
    if (doc)
      doc.save(
        `VehicleLoan_EMI_Slip_${loan.loanAccountNumber}_${emi.installmentNo}.pdf`
      );
  };

  return (
    <div className="viewemiloandata-container">
      <header className="viewemiloandata-headerbar">
        <div className="viewemiloandata-company">
          <img
            src={company?.logoUrl || "/techvisionlogo.jpg"}
            alt="Company Logo"
            className="viewemiloandata-logo"
          />
          <div className="viewemiloanddata-company-details">
            <h2 className="viewemiloandata-companyname">
              {company?.name || "TechVision Finance"}
            </h2>
            <p>
              <strong>Email:</strong> {company?.email} 
            </p>
            <p>
              <strong>Phone:</strong> {company?.contact}
            </p>
          </div>
        </div>
      </header>

      <div className="viewemiloandata-loaninfo">
        <h3>Loan & Customer Details</h3>
        <p>
          <strong>Customer Name:</strong> {loan?.memberName}
        </p>
        <p>
          <strong>Loan Account No:</strong> {loan?.loanAccountNumber}
        </p>
        <p>
          <strong>Total EMIs:</strong> {count}
        </p>
      </div>

      <div className="viewemiloandata-table-container">
        <h3>Loan EMI Schedule</h3>

        {emis.length === 0 ? (
          <p>No EMIs found</p>
        ) : (
          <table className="viewemiloandata-table">
            <thead>
              <tr>
                <th>EMI No</th>
                <th>Due Date</th>
                <th>Amount</th>
                <th>Status</th>
                <th>Paid Date</th>
                <th>Action</th>
                <th>Slip</th>
              </tr>
            </thead>

            <tbody>
              {emis.map((emi, i) => {
                const isPaid = emi.status?.toLowerCase() === "paid";
                const isPartial = emi.status?.toLowerCase() === "partial";
                const isPending = emi.status?.toLowerCase() === "pending";
                const nextEmi = i < emis.length - 1 ? emis[i + 1] : null;
                return (
                  <tr
                    key={emi.id}
                    className="emi-row"
                    style={{
                      background: isPaid
                        ? "#e8f7e8"
                        : isPartial
                        ? "#fff6e0"
                        : "#ffecec",
                    }}
                  >
                    <td>{emi?.emiNumber||emi.installmentNo}</td>
                    <td>{formatDate(emi?.dueDate)}</td>
                    <td>
                      {formatCurrency(emi?.emiAmount)}
                      <div className="emi-small">
                        <span>Principal: {formatCurrency(emi?.principalComponent)}</span>
                        <br />
                        <span>Interest: {formatCurrency(emi?.interestComponent)}</span>
                      </div>
                    </td>
                    <td style={{ fontWeight: "bold" }}>
                      {isPaid && <span style={{ color: "green" }}>Paid</span>}
                      {isPartial && <span style={{ color: "#ff9800" }}>Partial</span>}
                      {isPending && <span style={{ color: "red" }}>Pending</span>}

                      {isPartial && (
                        <div className="emi-small">
                          Paid: {formatCurrency(emi?.partiallyPaidAmount)} <br />
                          Remaining: {formatCurrency(emi?.emiBalance)}
                        </div>
                      )}

                      {isPaid && emi.lastPaidAmount && (
                        <div className="emi-small">
                          Last Paid: {formatCurrency(emi?.lastPaidAmount)}
                        </div>
                      )}

                      <div className="emi-small">
                        Outstanding: {formatCurrency(emi?.outstanding)}
                      </div>
                    </td>
                    <td>{emi.paidDate ? formatDate(emi?.paidDate) : "-"}</td>
                    <td>
                      {isPaid ? (
                        <span style={{ color: "green", fontWeight: "bold" }}>✔ Paid</span>
                      ) : (
                        <div className="emi-actions">
                          <button className="btn-full" onClick={() => handlePayClick(emi)}>
                            Pay 
                          </button>
                        </div>
                      )}
                    </td>
                    <td>
                      {isPaid ? (
                         <button
                            className="grouploanemidetails-emi-reciept"
                            onClick={() =>
                              navigate("/grouploan/grouploanreport/GroupLoanEmiDetails/reciept", {
                                state: {emi,loan,nextEmi},
                              })
                            }
                          >
                            Receipt
                          </button>
                      ) : (
                        <span style={{ color: "gray" }}>After Payment</span>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>

      {showModal && (
        <div className="viewemiloandata-modal-overlay">
          <div className="viewemiloandata-modal">
            <h3>
              {paymentData.type === "full" &&
                `Pay Full EMI (No: ${selectedEmi?.emiNumber})`}
              {paymentData.type === "partial" &&
                `Partial Payment (No: ${selectedEmi?.emiNumber})`}
              {paymentData.type === "advance" &&
                `Advance EMI Payment (No: ${selectedEmi?.emiNumber})`}
            </h3>

            {paymentData.type === "partial" && (
              <p style={{ color: "red", fontWeight: "bold" }}>
                Note: Partial payment accepted. Remaining amount will stay
                pending.
              </p>
            )}

            <label>
              Amount:
              <input
                type="number"
                value={paymentData.amountPaid}
                onChange={(e) =>
                  setPaymentData({
                    ...paymentData,
                    amountPaid: e.target.value,
                  })
                }
              />
            </label>

            <label>
              Mode:
              <select
                value={paymentData.paymentMode}
                onChange={(e) =>
                  setPaymentData({
                    ...paymentData,
                    paymentMode: e.target.value,
                  })
                }
              >
                <option value="Cash">Cash</option>
                <option value="Card">Card</option>
                <option value="UPI">UPI</option>
                <option value="NetBanking">Net Banking</option>
              </select>
            </label>

            <label>
              Date:
              <input
                type="date"
                value={paymentData.paymentDate}
                onChange={(e) =>
                  setPaymentData({
                    ...paymentData,
                    paymentDate: e.target.value,
                  })
                }
              />
            </label>

            <label>
              Remark:
              <input
                type="text"
                value={paymentData.remark}
                onChange={(e) =>
                  setPaymentData({
                    ...paymentData,
                    remark: e.target.value,
                  })
                }
              />
            </label>

            <div className="modal-actions">
              <button onClick={() => setShowModal(false)}>Cancel</button>
              <button
                onClick={handleSubmitPayment}
                disabled={submitting}
              >
                {submitting ? "Processing..." : "Confirm"}
              </button>
            </div>
          </div>
        </div>
      )}

      {showPreview && previewUrl && (
        <div className="viewemiloandata-modal-overlay">
          <div
            className="viewemiloandata-modal"
            style={{ width: "80%", height: "90%" }}
          >
            <h3>Slip Preview</h3>
            <iframe
              src={previewUrl}
              style={{
                width: "100%",
                height: "80%",
                border: "none",
              }}
            />
            <div className="modal-actions">
              <button
                onClick={() => {
                  setShowPreview(false);
                  URL.revokeObjectURL(previewUrl);
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="account-ledger-list-pagination-section">
            <div className="account-ledger-list-pagination-div">
              <button
                onClick={() => setCurrentPage(currentPage - 1)}
                disabled={currentPage === 1}
              >
                ⬅ Prev
              </button>
              <span>
                Page {currentPage} of {totalPages}
              </span>
              <button
                onClick={() => setCurrentPage(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Next ➡
              </button>
            </div>
         </div>

      <footer className="viewemiloandata-footer">
        <p>© 2025 {company?.name || "TechVision Finance"} Pvt. Ltd.</p>
        <p>{company?.tagline || "Empowering Dreams"}</p>
      </footer>
    </div>
  );
};

export default VehicleLoanEmiDetails;